import { DISPLAY_DATE_FORMAT } from 'constants/dates';
import { format } from 'date-fns';

export const epochToISO = (epoch: number) =>
  epoch ? format(epoch, DISPLAY_DATE_FORMAT) : '';

export const dateStringToEpoch = (date: string): number =>
  new Date(date).getTime();

export const addDaysToDate = (date: string, days: number) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d.toString();
};
